import React from 'react';

const MarketOddsTable = ({ selectedMarkets, oddDetail}) => {
  if (!selectedMarkets && !oddDetail) {
    return null;
  }


  return oddDetail.map((detail) => {
    const { markets } = detail;

    return (
      <tr key={detail.roundMinute || detail.dateTime}>
        {selectedMarkets.map((market, idx) => {
          if (market && market.selections !== undefined) {
            const { id, selections } = market;
            return (
              <td key={id}>
                <div className="table-f">
                  {selections.map((selection) => (
                    <div key={`${selection.id}`}>
                      {markets && markets[id]?.[selection.id]?.toFixed(2) || '-'}
                    </div>
                  ))}
                </div>
              </td>
            );
          }
          const moKey = `market-odds-${idx}`;
          return <td key={moKey}>-</td>;
        })}
      </tr>
    );
  });
};

export default MarketOddsTable;

